






// @ is an alias to /src
import { AloPlat } from '@/models/alo/AloPlat'
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import BasePlat from '@/components/carte/BasePlat'

@Component({
  name: 'SubTitle'
})
export default class SubTitle extends mixins(BasePlat) {    
}
